import React, {useCallback, useContext} from "react";
import {LinesContext, UserContext} from '@web/hooks/context';
import {useDispatch, useSelector} from "react-redux";
import actions from "@web/redux/collections/actions";
import PropTypes from "prop-types";

CollectionFetch.propTypes = {
  collectionId: PropTypes.string.isRequired,
  component: PropTypes.elementType.isRequired,
  transformer: PropTypes.func,
}

function CollectionFetch({collectionId, component, ...props}) {
  const dispatch = useDispatch();
  const [userId, h] = useContext(UserContext);
  const ctx = useContext(LinesContext);
  const dataPath = [h, collectionId].join("/");
  const collectionPath = [ctx.basePath, collectionId].join("/");
  const list = useSelector((state) => {
    // console.log("useSelector:collectionId", collectionId, state.Collections?.[collectionId]?.list);
    return state.Collections?.[collectionId]?.list;
  });
  // const items = useSelector((state) => state.Collections?.[collectionId]?.items);
  const table = useSelector((state) => state.Collections?.[collectionId]?.table);
  const collection = useSelector((state) => {
    return state.Collections?.data?.[ctx.basePath + "/collections/" + collectionId];
  });
  const pageToken = useSelector((state) => state.Collections?.[collectionId]?.pageToken);

  const loadContent = () => {
    !!collectionId &&
    dispatch(actions.fetch(collectionId,{
      path: dataPath,
    }));
  };

  React.useEffect(() => {
    !!collection?.collectionId &&
    dispatch(actions.sync(collection.collectionId));
  }, [collection?.collectionId]);

  const pageNext =
    useCallback(() =>
      dispatch(actions.fetch(collection?.collectionId, {
        path: dataPath,
        pageToken,
      })), [pageToken, dispatch]);

  React.useEffect(() => {
    collection?.collectionId &&
    !collection?.live &&
    collection.basePath === "/" &&
    loadContent();
  }, [collection?.collectionId]);

  if (!userId) {
    return null;
  }

  return React.createElement(
    component,
    {
      collection,
      ...props,
      collectionId,
      table,
      list,
      // items,
      pageNext,
      hasMore: !!pageToken,
      collectionPath,
      // dataPath,
    },
  );
}

export default CollectionFetch;
